<template>
  <main class="flex-1 p-8 overflow-y-auto bg-secondary font-light">
    <div class="mb-6">
      <h1 class="text-3xl font-serif italic mb-2">Reviews Management</h1>
      <p class="text-gray-600">
        Review and moderate customer reviews submitted by clients
      </p>
    </div>

    <TabNav :tabs="tabs" />
  </main>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import TabNav from '@/components/TabNav.vue';
import AdminPendingReviews from '@/app/pages/admin-reviews/AdminPendingReviews.vue';
import AdminAllReviews from '@/app/pages/admin-reviews/AdminAllReviews.vue';
import AdminPublishedReviews from '@/app/pages/admin-reviews/AdminPublishedReviews.vue';

// Create refs to access the review components
const pendingReviewsRef = ref<InstanceType<typeof AdminPendingReviews> | null>(null);
const publishedReviewsRef = ref<InstanceType<typeof AdminPublishedReviews> | null>(null);

// Compute counts from the stats
const pendingCount = computed(() => {
  return pendingReviewsRef.value?.stats?.total_pending || 0;
});

const publishedCount = computed(() => {
  return publishedReviewsRef.value?.stats?.total_published || 0;
});

const tabs = computed(() => [
  {
    value: 'pending-reviews',
    label: 'Pending Reviews',
    component: AdminPendingReviews,
    count: pendingCount.value,
    props: {
      ref: pendingReviewsRef,
    },
  },
  {
    value: 'all-reviews',
    label: 'All Reviews',
    component: AdminAllReviews,
  },
  {
    value: 'published-reviews',
    label: 'Published Reviews',
    component: AdminPublishedReviews,
    count: publishedCount.value,
    props: {
      ref: publishedReviewsRef,
    },
  },
]);
</script>

